import React, { useState, useMemo } from 'react'
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { compose } from 'redux'
import config from 'config'
import PropTypes from 'prop-types'
import scriptLoader from 'react-async-script-loader'
import { Collapse } from 'react-collapse'
import cx from 'classnames'

import { collapsibleClick } from '@cred/react-analytics/events'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'

import { loadLendersRates } from 'common/utils/rates'
import LendersList from 'components/lenders-list'

import styles from './styles.nodule.scss'

const LIMIT = 3

const ShortenedRateTableApp = ({
  isScriptLoaded,
  ctaUrl,
  trackSnowplowEvent,
  theme = '',
  availableLenders = [],
}) => {
  const [isOpen, setOpen] = useState(false)

  const toggleLenderList = () => {
    setOpen(!isOpen)

    trackSnowplowEvent(collapsibleClick, {
      text: isOpen ? 'Hide additional lenders' : 'Show additional lenders',
      action: isOpen ? 'collapse' : 'expand',
    })
  }

  const lenders = useMemo(() => {
    if (isScriptLoaded) {
      return loadLendersRates({
        availableLenders,
        filters: { vertical: 'refi' },
      })
    }

    return []
  }, [isScriptLoaded, availableLenders])

  const totalLender = lenders.length

  return (
    <div>
      <LendersList
        lenders={lenders.slice(0, LIMIT)}
        ctaUrl={ctaUrl}
        openUrlInNewTab
        theme={theme}
        name="StudentLoanRefi"
      />
      {lenders && lenders.length > LIMIT && (
        <div>
          <Collapse isOpened={isOpen}>
            <LendersList
              lenders={lenders.slice(LIMIT)}
              ctaUrl={ctaUrl}
              openUrlInNewTab
              theme={theme}
              name="StudentLoanRefi"
            />
          </Collapse>
          <div className={styles.viewMoreSection} onClick={toggleLenderList}>
            <p className={`${styles.viewMore} align-center secondary500`}>
              {isOpen ? 'Hide additional lenders' : `View ${totalLender - LIMIT} more lenders`}
              <span
                className={cx('cred-icon', {
                  'icon-chevron-up': isOpen,
                  'icon-chevron-down': !isOpen,
                })}
              />
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

ShortenedRateTableApp.propTypes = {
  ctaUrl: PropTypes.string.isRequired,
  isScriptLoaded: PropTypes.bool,
  trackSnowplowEvent: PropTypes.func,
  theme: PropTypes.string,
  availableLenders: PropTypes.instanceOf(Array),
}

export { ShortenedRateTableApp }

export default compose(
  scriptLoader(config.ratesLibraryUrl),
  withSnowplowContexts,
)(ShortenedRateTableApp)
